export const userKeys = {
  current: () => ['currentUser'],
  inOrganization: (organizationId: number | string) => ['organizationId', organizationId],
  currentPermissions: () => ['currentPermissions'],
  adminUsers: () => ['adminUsers'],
};
